module.exports = __webpack_public_path__ + "static/media/device_plus_app.88e5d105.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/device_plus_app.png
// module id = 547
// module chunks = 0